import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import { Spin, Typography, Tooltip } from "antd";
import { StarFilled } from "@ant-design/icons";
import ProductSectionNew from "../../components/common/ProductSectionNew";
import BestValueProductSection from "../../components/common/BestValueProductSection";
import TopValuePicksComparison from  "../../components/common/TopValuePicksComparison";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import { trackingService } from "../../services/api/trackingService.js";
import joyLogo from "../../assests/Images/joyLogo.png";
import "./ProductPage.css";
import ProductListSection from "../../components/common/ProductListSection";
import HomeIcon from "../../assests/Images/home.svg";
import WebIcon from "../../assests/Images/web.svg";
import LogoIcon from "../../assests/Images/kangaroo.webp";
import SearchIcon from "../../assests/Images/list.svg";
import { SidebarNav, MobileBottomNav } from "../../components/common/ChatNavigation.js";

export default function ProductPage() {
  const { phoneNumber, id } = useParams();
  const { Text } = Typography;
  const isDesktop = useMediaQuery("(min-width:768px)");
  const [activeNav, setActiveNav] = useState(2);
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);

  const bottomNavHeight = isDesktop ? 0 : 50;
  const icons = [WebIcon, LogoIcon, SearchIcon];
  const routes = [
    "https://www.shopperoo.us/",
    "/chatbot",
    "/shopping",
  ];

  // Track page visit when component mounts
  useEffect(() => {
    if (!phoneNumber && !id) return;

    setLoading(true);

    UIRecommendationAPIService.uiRecommend(phoneNumber, id)
      .then((response) => {
        setProductData(response || {});

        // Track page visit after data is loaded
        if (phoneNumber && response) {
          trackingService.trackPageVisit(
            phoneNumber,
            id || 'unknown',
            response?.keywords || response?.display_keywords || 'unknown'
          );
        }
      })
      .catch((err) => console.error("Error fetching product data:", err))
      .finally(() => setLoading(false));
  }, [phoneNumber, id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "4rem" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", height: "100vh", bgcolor: "white" }}>
        {/* Desktop sidebar */}
        {isDesktop && (
          <SidebarNav
            icons={icons}
            activeNav={activeNav}
            setActiveNav={setActiveNav}
            routes={routes}
          />
        )}

        {/* Main area */}
        <Box
          sx={{
            position: "relative",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            minWidth: 0,
          }}
        >
          {!productData ? (
            <p style={{ textAlign: "center", marginTop: "4rem" }}>No data available</p>
          ) : (
            <main
              className="product-section-new"
              style={{
                flex: 1,
                overflowY: "auto",
                paddingBottom: !isDesktop ? bottomNavHeight : 0,
              }}
            >
              <BestValueProductSection
                title={`Best value pick for : ${
                  productData?.display_keywords ||
                  productData?.keywords?.replace(/\s*AND\s*/g, ", ")
                }`}
                subtitle={
                  <span className="section-subtitle">
                    (Best mix of price, quality & features across stores)
                  </span>
                }
                iconType="thumbsUp"
                backgroundColor="#005cff"
                fontColor="#ffffff"
                products={productData?.best_value_products[0]}
                pros={productData?.comparison_data?.best_value_product_pros}
                cons={productData?.comparison_data?.best_value_product_cons}
                phoneNumber={phoneNumber}
              />

              <TopValuePicksComparison
                products={productData?.comparison_data}
                bestValueProducts={productData?.best_value_products}
                phoneNumber={phoneNumber}
              />

              <ProductListSection
                bestValueProducts={productData?.best_value_products}
                topRatedProducts={productData?.top_rated_products}
                lowestPricedProducts={productData?.lowest_priced_products}
                phoneNumber={phoneNumber}
                amazonSavingamount={productData?.amazon_savings_amount}
              amazonSavingPercentage={productData?.amazon_savings_percent}
              />
            </main>
          )}

          {/* Fixed bottom nav */}
          {!isDesktop && (
            <Box
              sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                height: bottomNavHeight,
                bgcolor: "white",
                boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
                zIndex: 1200,
              }}
            >
              <MobileBottomNav
                icons={icons}
                activeNav={activeNav}
                setActiveNav={setActiveNav}
                bottomNavHeight={bottomNavHeight}
                routes={routes}
              />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}